import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.widgets', {
        url: '/widgets',
        component: 'companyManageApplicationIntegrationDevelopersWidgets',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/widgets/widgets.state.js